import React, { FC, useCallback, useMemo } from 'react'

import { Dropdown } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'
import { ProjectStatusTxt } from 'src/components/molecules'

import { useProjectStatus } from 'src/hooks'
import { ProjectStatusType } from 'src/types'

type Props = {
  projectStatuses: ProjectStatusType[]
  currentStatus?: ProjectStatusType
  value: string | undefined
  selectOption: (name: string | undefined) => void
  className?: string
}

export const ProjectStatusDropdown: FC<Props> = ({
  projectStatuses,
  currentStatus,
  value,
  selectOption,
  className,
}) => {
  const { getHasArchived } = useProjectStatus()

  const sortedProjectStatuses = useMemo(() => {
    return [...projectStatuses].sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
  }, [projectStatuses])

  const hasArchived = useMemo(() => {
    return getHasArchived(projectStatuses)
  }, [getHasArchived, projectStatuses])

  const isOptionDisabled = useCallback(
    (status: ProjectStatusType) => {
      // アーカイブが存在しない場合は常に非活性にしない
      if (!hasArchived) {
        return false
      }

      // プロジェクトのステータスがアーカイブ以外の場合、停止中はdisabledにする
      return currentStatus?.name !== 'archived' && status.name === 'stopped'
    },
    [currentStatus, hasArchived]
  )

  const options = useMemo(() => {
    return [
      {
        value: undefined,
        children: <Txt>未選択</Txt>,
      },
      ...sortedProjectStatuses.map(status => {
        return {
          value: status.name,
          children: <ProjectStatusTxt status={status} className="tw-font-bold" />,
          disabled: isOptionDisabled(status),
        }
      }),
    ]
  }, [isOptionDisabled, sortedProjectStatuses])

  return (
    <div className={className}>
      <Dropdown
        value={value}
        // NOTE: UI Componentsを大きくリファクタリングする予定がある。Dropdownのoptionsのvalueはundefinedを許容しないため、UI Components側を修正するのが理想だが、リファクタリングの方針が決まるまでは一時的にts-ignoreを使用する
        // @ts-ignore
        options={options}
        selectOption={option => selectOption(option.value as string | undefined)}
      />
    </div>
  )
}
